import { jsx as _jsx } from "react/jsx-runtime";
import { mapRecord } from 'console/shared/utils/entries';
import { isEqual } from 'lodash';
import { memo, useCallback, useContext, useEffect, useMemo, } from 'react';
import { DashboardControl } from './types';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const DashboardControlProvider = memo(function DashboardControlProvider(props) {
    const { setDashboardUISettings, initial_dashboard_ui_settings, setIsDashboardUISettingsCancel, setIsDashboardUISettingsChanged, sorting_mode, children, } = props;
    const onDevicePin = useCallback((device_id) => {
        setDashboardUISettings((prev_content) => {
            const dashboard_ui_settings = mapRecord(prev_content, (id, ui_settings) => {
                if (device_id.toString() === id) {
                    const pinned_ui_settings = {
                        ...ui_settings,
                        pinned: !ui_settings.pinned,
                    };
                    return [id, pinned_ui_settings];
                }
                return [id, ui_settings];
            });
            setIsDashboardUISettingsChanged();
            if (isEqual(dashboard_ui_settings, initial_dashboard_ui_settings)) {
                setIsDashboardUISettingsCancel();
            }
            return dashboard_ui_settings;
        });
    }, [initial_dashboard_ui_settings]);
    const onDeviceBlockInteractionEnd = useCallback((layout) => {
        setDashboardUISettings((prev_content) => {
            const new_layout = layout.map(({ i: id, h: height, w: width, x, y }) => {
                const prev_ui_settings = prev_content[id] ?? {};
                return [
                    id,
                    {
                        ...prev_ui_settings,
                        width,
                        height,
                        x,
                        y,
                    },
                ];
            });
            const dashboard_ui_settings = Object.fromEntries(new_layout);
            setIsDashboardUISettingsChanged();
            if (isEqual(dashboard_ui_settings, initial_dashboard_ui_settings)) {
                setIsDashboardUISettingsCancel();
            }
            return dashboard_ui_settings;
        });
    }, [initial_dashboard_ui_settings]);
    const onDevicePositionChange = useCallback((devices) => setDashboardUISettings((prev_dashboard_ui_settings) => {
        const dashboard_ui_settings = mapRecord(prev_dashboard_ui_settings, (device_id, ui_settings) => [
            device_id,
            {
                ...ui_settings,
                position: devices.findIndex((panel) => panel.id == Number(device_id)) ?? -1,
            },
        ]);
        setIsDashboardUISettingsChanged();
        if (isEqual(initial_dashboard_ui_settings, dashboard_ui_settings)) {
            setIsDashboardUISettingsCancel();
        }
        return dashboard_ui_settings;
    }), [initial_dashboard_ui_settings]);
    const [is_devices_wrapped, unwrapDevices, , toggleDevicesWrap] = useBooleanState(false);
    useEffect(() => {
        if (!sorting_mode) {
            unwrapDevices();
        }
    }, [sorting_mode]);
    const value = useMemo(() => ({
        is_devices_wrapped,
        toggleDevicesWrap,
        onDevicePositionChange,
        onDeviceBlockInteractionEnd,
        onDevicePin,
    }), [
        is_devices_wrapped,
        toggleDevicesWrap,
        onDevicePositionChange,
        onDevicePin,
        onDeviceBlockInteractionEnd,
    ]);
    return (_jsx(DashboardControl.Provider, { value: value, children: children }));
});
export const useDashboardControl = () => useContext(DashboardControl);
